import { darken, lighten, TypeAction, useTheme } from "@mui/material";
import {
  useActionColors,
  useActionGroupColors,
  useContainerColor,
  useOnContainerColor,
} from "shared-ts-mui";

export interface UseResolveColorsReturnType {
  onColor: string;
  onContainerColorWhenSelected: string;
  containerColorWhenSelected: string;
  containerColorOnHover: string;
  containerColorWhenSelectedOnHover: string;
}

export const useResolveItemColors = (): UseResolveColorsReturnType => {
  const theme = useTheme();
  const action = useActionColors();
  const containerColorWhenSelected = useContainerColor("primary");
  const onSecondaryContainerColor = useOnContainerColor("secondary");
  const containerColorOnHover = theme.palette.action.hover;
  const containerColorWhenSelectedOnHover =
    theme.palette.mode === "light"
      ? darken(containerColorWhenSelected, theme.palette.action.hoverOpacity)
      : lighten(containerColorWhenSelected, theme.palette.action.hoverOpacity);

  return {
    onColor: theme.palette.text.primary,
    onContainerColorWhenSelected: onSecondaryContainerColor,
    containerColorWhenSelected: action.selected ?? containerColorWhenSelected,
    containerColorOnHover: containerColorOnHover,
    containerColorWhenSelectedOnHover:
      action.hover ?? containerColorWhenSelectedOnHover,
  };
};

export type UseResolveGroupColorsReturnType = Partial<TypeAction>;

export const useResolveActionGroupColors =
  (): UseResolveGroupColorsReturnType => {
    const actionGroup = useActionGroupColors();

    return {
      primary: actionGroup?.primary,
      primaryText: actionGroup?.primaryText,
      active: actionGroup?.active,
      activeText: actionGroup?.activeText,
      activatedOpacity: actionGroup?.activatedOpacity,
      disabled: actionGroup?.disabled,
      disabledText: actionGroup?.disabledText,
      disabledOpacity: actionGroup?.disabledOpacity,
      disabledBackground: actionGroup?.disabledBackground,
      hover: actionGroup?.hover,
      hoverText: actionGroup?.hoverText,
      selected: actionGroup?.selected,
      selectedText: actionGroup?.selectedText,
      hoverOpacity: actionGroup?.hoverOpacity,
      selectedOpacity: actionGroup?.selectedOpacity,
      focus: actionGroup?.focus,
      focusText: actionGroup?.focusText,
      focusOpacity: actionGroup?.focusOpacity,
    };
  };

export const useResolveActionColors = (): UseResolveGroupColorsReturnType => {
  const action = useActionColors();

  return {
    primary: action?.primary,
    primaryText: action?.primaryText,
    active: action?.active,
    activeText: action?.activeText,
    activatedOpacity: action?.activatedOpacity,
    disabled: action?.disabled,
    disabledText: action?.disabledText,
    disabledOpacity: action?.disabledOpacity,
    disabledBackground: action?.disabledBackground,
    hover: action?.hover,
    hoverText: action?.hoverText,
    selected: action?.selected,
    selectedText: action?.selectedText,
    hoverOpacity: action?.hoverOpacity,
    selectedOpacity: action?.selectedOpacity,
    focus: action?.focus,
    focusText: action?.focusText,
    focusOpacity: action?.focusOpacity,
  };
};
